// src/pages/packages/EditPackage.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditPackage from "../../components/packages/FormAddEditPackage";
import useGetPackage from "../../hooks/packages/useGetPackage";
import LoadingPage from "../../components/global/LoadingPage";

const EditPackage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, package: pkg } = useGetPackage(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/packages");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPackage
                isEdit={true}
                currentData={pkg}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditPackage;
